/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import class_componentImg from 'assets/images/class-component.jpg'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Компоненты-классы</h2>
    <p className={styles.description}>
      Если необходимо добавить динамику, компоненты создаются как классы, потому что компоненты-функции (до хуков)
      ограничены возможностью создания разметки по полученным пропсам.{' '}
    </p>
    <img className={styles.img} src={class_componentImg} alt="class-component" />
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Обычный ES6 класс, поэтому применяются все правила: конструктор, методы, контекст (this).
      </li>
      <li className={styles.list__item}>
        Обязательно расширяет базовый класс <code className={styles.code}>React.Component</code>.
      </li>
      <li className={styles.list__item}>
        Действует как функция, которая получает <code className={styles.code}>props</code>, но также реализует приватное
        внутреннее состояние.
      </li>
      <li className={styles.list__item}>
        Необходимо объявить обязательный метод <code className={styles.code}>render()</code>, который вызывается по
        умолчанию и возвращает JSX-разметку.
      </li>
      <li className={styles.list__item}>
        Каждый раз при использовании компонента-класса, React будет создавать экземпляр компонента (класса), поэтому
        доступ к пропсам происходит через <code className={styles.code}>this.props</code>.
      </li>
      <li className={styles.list__item}>
        Можно определить кастомные методы класса и использовать их в любом месте, в том числе внутри JSX, вызывать или
        передавать детям как пропсы.
      </li>
      <li className={styles.list__item}>Когда изменяется состояние или пропcы компонента, происходит его ре-рендер.</li>
    </ul>
    <CopyBlock
      text={`// Отделяйте именованные импорты, это повышает читаемость кода
import React, { Component } from 'react';

class MyClassComponent extends Component {
  static defaultProps = {};

  static propTypes = {};

  render() {
    return <div>Class Component</div>;
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
